module.exports = __webpack_public_path__ + "static/media/Pages.a1582097.svg";